export default __webpack_public_path__ + "static/media/no-appointment-icon.5ce0685d.svg";